<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdb-0">
      <a @click="$emit('toggleSelection')">
        <b-icon class="icon is-pulled-right has-text-icon-more"
                icon="close">
        </b-icon>
      </a>
      <span class="mgl-10px has-text-weight-bold is-size-4">
          {{$t('general.select.title')}}
      </span>
    </div>
    <div class="column is-12 pdb-0 border-entete">
        <span class="mgl-10px has-text-icon-more is-size-7">
          {{ $t('general.select.sousTitle',
          { numberProduit: selectionGetter.length }) }}
        </span>
    </div>
    <div class="column is-12-tablet hauteur-panier is-marginless"
         v-if="selectionGetter.length > 0">
      <div class="overflow-auto">
        <display-ligne-in-selection
          :selection="newSelection"
          :isAlreadySelect="false"
          :title="newSelection.length > 0 ?
          $t('general.select.newSelection') : ''"
          :info="newSelection.length > 0 ? '' :
          $t('addProduitsAssocies.selection.noNewProduct')">
        </display-ligne-in-selection>
        <display-ligne-in-selection
          v-if="selectionFromProduct.length > 0"
          :selection="selectionFromProduct"
          class="mgt-20px"
          :isAlreadySelect="true"
          :title="$t('addProduitsAssocies.selection.produitAssocieFromProduit',
          { reference: reference})">
        </display-ligne-in-selection>
      </div>
    </div>
    <div class="column is-12 hauteur-panier is-flex" v-else>
      <div class="has-text-centered mg-auto">
        <div class="logo__panier_vide mg-auto"></div>
        <p class="has-text-weight-bold is-size-5">
          {{$t('general.select.selectVide')}}
        </p>
        <p>{{$t('general.select.noProduit')}}</p>
      </div>
    </div>
    <div class="column is-12 hauteur-bas-panier
    border-pied columns is-marginless is-vcentered">
      <button class="button pdv-0 column is-narrow pdh-20px
      is-pulled-right"
              :class="[{'is-select pointer-events-none': selectionGetter.length === 0},
        {'is-addOrEdit': selectionGetter.length > 0}]"
              @click="$emit('ajoutProduitAssociesAuProduit')">
        {{$t('general.button.add')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import DisplayLigneInSelection
  from '@/components/bodac/produit/produitAssocie/displayLigneInSelection';

const Produit = createNamespacedHelpers('produit');

export default {
  name: 'ProduitProduitAssocieSelection',
  props: {
    reference: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    ...Produit.mapGetters({
      selectionGetter: 'selection',
    }),
    newSelection() {
      return this.selectionGetter.filter((produit) => { return !produit.isAlreadySelect; });
    },
    selectionFromProduct() {
      return this.selectionGetter.filter((produit) => { return produit.isAlreadySelect; });
    },
  },
  components: {
    DisplayLigneInSelection,
  },
};

</script>
